import React from 'react';
import { withRouter } from 'react-router-dom';
import { Card, List, Checkbox, Popup, Dropdown, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Loader, Dimmer } from 'semantic-ui-react'


class LoginAccessSetting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            signUpAccess:props.selectedOrganisation.autoSignUp ? props.selectedOrganisation.autoSignUp : false,
            loader:false
        }
    }
   
    async onAutoSignUpToggle() {
        
        this.setState({loader:true},async()=>{
            await dispatch.organizationUnit.updateOrganization({ _id: this.props.selectedOrganisation.id, autoSignUp: !this.state.signUpAccess })
            this.setState({signUpAccess:!this.state.signUpAccess,loader:false})
            // Folllowing changes are made for KLM-8906
            await dispatch.app.setSelectedOrganisationData(this.props.selectedOrganisation)
        })
    }
    
    render() {

        return (
            <div className="general-setting">
                <Card>
                    <Card.Header>
                        Login Access Setting
                    </Card.Header>
                    <Card.Content className="pad_0">
                        <List divided verticalAlign='middle' >
                            <List.Item className="multiLine">
                                <List.Content >
                                    <List.Header style={{display:"inline"}}>
                                        Enable Auto SignUp
                                    </List.Header>
                                    <List.Content style={{marginTop:"-2px"}} floated='right'>
                                        <Checkbox toggle
                                        checked={this.state.signUpAccess}
                                        onChange={() => this.onAutoSignUpToggle()}
                                        />
                                    </List.Content>
                                </List.Content>
                            </List.Item>
                        </List>
                    </Card.Content>
                </Card>
                <Dimmer inverted active={this.state.loader} page={true}>
                    <Loader content={"please wait..."} size="large"/>
                </Dimmer>
            </div>
        );
    }
}

export default withRouter(LoginAccessSetting);